import { Action } from "@/constants/events";
import { MenuItemCard } from "@/custom-types/MenuItemCard";

import { useEventTracker } from "./useEventTracker";

const useMenuItemEvents = () => {
  const { publishEvent } = useEventTracker();

  const publishMenuItemImpressionEvent = (
    menuItem: MenuItemCard,
    eventCategory: string,
  ) => {
    return publishEvent({
      action: Action.impression,
      brandId: menuItem.brand?.id,
      category: eventCategory,
      dispensaryId: menuItem.dispensary.id,
      label: "menu item offer card",
      menuItemId: menuItem.id,
      productId: menuItem.product?.id,
      strainId: menuItem.strain?.id,
    });
  };

  const publishMenuItemClickEvent = (
    menuItem: MenuItemCard,
    eventCategory: string,
  ) => {
    return publishEvent({
      action: Action.click,
      brandId: menuItem.brand?.id,
      category: eventCategory,
      dispensaryId: menuItem.dispensary.id,
      label: "menu item offer card",
      menuItemId: menuItem.id,
      productId: menuItem.product?.id,
      strainId: menuItem.strain?.id,
    });
  };
  return { publishMenuItemClickEvent, publishMenuItemImpressionEvent };
};

export default useMenuItemEvents;
